import { v4 as uuidv4 } from "uuid";
function convertUTCToLocalDate(date) {
  if (!date) {
    return date;
  }
  date = new Date(date);
  date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  return date;
}

function convertLocalToUTCDate(date) {
  if (!date) {
    return date;
  }
  date = new Date(date);
  date = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
  return date;
}

const sanitizeFileName = (name) => {
 
  return  `${uuidv4()}-${name
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/[^a-z0-9.-]/g, "")}`; // Remove unwanted characters
};

export { convertUTCToLocalDate, convertLocalToUTCDate, sanitizeFileName };
